import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import { Loader2 } from 'lucide-react';
import SiteHeader from './SiteHeader';
import SiteFooter from './SiteFooter';
import { VenmoPaymentStep } from './reserve/VenmoPaymentStep';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const ReservationStatus = () => {
  const { code } = useParams();
  const [reservation, setReservation] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    const load = () => axios.get(`${BACKEND_URL}/api/reserve/${code}`).then(r => setReservation(r.data)).catch(() => setNotFound(true));
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, [code]);

  return (
    <div className="min-h-screen bg-cream-50" data-testid="reservation-status-page">
      <SiteHeader active="reserve" />
      <section className="relative overflow-hidden bg-[#1a0d10] text-white py-14 md:py-20 px-4 md:px-6">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,rgba(124,29,51,0.25),transparent_55%)]" />
        <div className="absolute inset-0 grain" />
        <div className="max-w-3xl mx-auto relative z-10">
          <p className="eyebrow text-white/50 mb-4">Reservation</p>
          <h1 className="font-display text-4xl sm:text-5xl md:text-6xl font-medium tracking-tighter leading-[0.95]">
            <span className="font-mono text-3xl sm:text-4xl md:text-5xl tracking-[0.15em] text-[#d9a15b]">{code?.toUpperCase()}</span>
          </h1>
        </div>
      </section>
      <section className="py-12 md:py-16 px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          {notFound ? (
            <div className="bg-white rounded-2xl shadow-xl p-10 text-center border border-gray-200" data-testid="reservation-not-found">
              <p className="font-display text-3xl text-gray-900 mb-2">We couldn't find that reservation.</p>
              <p className="text-gray-600 mb-6">Double-check the code from your email, or start fresh.</p>
              <Link to="/reserve" className="inline-flex rounded-full bg-gradient-to-r from-wine to-burgundy text-white px-6 py-3 text-sm font-semibold">Reserve a bed</Link>
            </div>
          ) : !reservation ? (
            <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 animate-spin text-wine" /></div>
          ) : (
            <VenmoPaymentStep reservation={reservation} onUpdate={setReservation} />
          )}
        </div>
      </section>
      <SiteFooter />
    </div>
  );
};

export default ReservationStatus;
